export default __webpack_public_path__ + "static/media/location-premium.bffa2394.png";